/*
 * @Date: 2022-08-15 14:08:37
 * @LastEditTime: 2022-08-16 10:09:25
 * @Description:
 */
import { net_common } from "@/api/http";
export const API_Initialize = (...params) =>
  net_common.post("/api/STDSDC02C02/Initialize", ...params);

export const API_AddBopInfo = (...params) =>
  net_common.post("/api/STDSDC02C02/AddBopInfo", ...params);
